import { useMemo } from "react";
import { PDFTableColumn } from "components/PDF/Table";
import { View, Text } from "@react-pdf/renderer";
import moment from "moment";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import {
  ConsumoUnidade,
  ConsumoPdfQueryParams,
  ConsumoDto,
} from "core/features/consumo/typings";
import { getValorConsumo } from "core/features/consumo/helpers/getValorAplicadoConsumo";

function useExportarConsumoPdfColumns(
  consumo: ConsumoDto,
  filtro: ConsumoPdfQueryParams
): PDFTableColumn<ConsumoUnidade>[] {
  const mesAtual = moment(filtro.mes, "YYYY-MM").format("MMMM");
  const mesAnterior = moment(filtro.mes, "YYYY-MM")
    .subtract(1, "month")
    .format("MMMM");

  return useMemo(() => {
    const columns: PDFTableColumn<ConsumoUnidade>[] = [
      {
        title: "Unidade",
        flexGrow: 2.7,
        render: (original) => (
          <View>
            <Text>
              {original.blocoQuadra ? `${original.blocoQuadra}, ` : ""}
              {original.numero}
            </Text>
          </View>
        ),
      },
      {
        title: `Medição em ${mesAnterior}`,
        flexGrow: 2,
        textAlign: "right",

        render: (original) => (
          <View>
            <Text>
              {original.consumoUnidadeMesAnterior?.toFixed(3) ?? `0.000`}
            </Text>
          </View>
        ),
      },
      {
        title: `Medição em ${mesAtual}`,
        flexGrow: 2,
        textAlign: "right",

        render: (original) => (
          <View>
            <Text>{original.medidaAtual?.toFixed(3) ?? "0.000"}</Text>
          </View>
        ),
      },
      {
        title: `Consumo em ${mesAtual}`,
        flexGrow: 2,
        textAlign: "right",

        render: (original) => (
          <View>
            <Text>
              {Math.max(
                (original.medidaAtual ?? 0) -
                  (original.consumoUnidadeMesAnterior ?? 0),
                0
              ).toFixed(3)}
            </Text>
          </View>
        ),
      },
      {
        title: "Valor",
        textAlign: "right",
        flexGrow: 1,
        render: (original) => {
          const diferencaConsumo = Math.max(
            (original.medidaAtual ?? 0) -
              (original.consumoUnidadeMesAnterior ?? 0),
            0
          );

          const valorMonetario = getValorConsumo(diferencaConsumo, consumo);

          return (
            <View>
              <Text>R$ {formatCurrency(valorMonetario)}</Text>
            </View>
          );
        },
      },
    ];

    return columns;
  }, [consumo, mesAnterior, mesAtual]);
}

export default useExportarConsumoPdfColumns;
